import { IconButton, Stack, styled, SvgIcon, SxProps, useTheme } from '@mui/material';
import { chevronLeftIcon, chevronRightIcon } from '../config/icons';

export type PrevNextBtnsProps = {
  onPrev: () => void;
  onNext: () => void;
  sx?: SxProps;
};

const Btn = styled(IconButton)({
  width: '36px',
  height: '36px',
  fontSize: '20px',
});

export function PrevNextBtns({ onPrev, onNext, sx = {} }: PrevNextBtnsProps) {
  const { direction } = useTheme();

  return (
    <Stack direction="row" spacing={1} sx={{ ...sx }}>
      <Btn onClick={onPrev}>
        <SvgIcon
          sx={{
            width: '17px',
          }}
        >
          {direction === 'rtl' ? chevronRightIcon : chevronLeftIcon}
        </SvgIcon>
      </Btn>
      <Btn onClick={onNext}>
        <SvgIcon
          sx={{
            width: '17px',
          }}
        >
          {direction === 'rtl' ? chevronLeftIcon : chevronRightIcon}
        </SvgIcon>
      </Btn>
    </Stack>
  );
}
